import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import Modal from '../../../shared/modals/modal.component';
import Form from '../../../shared/forms/form.component';

import { CustomReportParamTypes } from '../../../shared/customReports/constants';

import TestCustomReportQueryParamModal from './testCustomReportQueryParamModalContainer.component';
import { useVerifyQueryLogic } from './useVerifyQueryLogic';

import { OptionsPropType } from '../../../shared/propTypes/common';
import { FormikPropTypes } from '../../../shared/forms/propTypes';

const paramTypesOptions = [
  { value: CustomReportParamTypes.query, label: CustomReportParamTypes.query },
  { value: CustomReportParamTypes.input, label: CustomReportParamTypes.input },
  { value: CustomReportParamTypes.validator, label: CustomReportParamTypes.validator },
];

const EditCustomReportQueryParamModal = ({
  formik,
  schema,
  hideCustomReportModalForParam,
  verifyParamOptionsQuery,
  isVisible,
  isVerifyingParamToEditQuery,
  reportParamToEditOptions,
  testCustomReportQueryParamModalData,
  hideTestCustomReportQueryParamModal,
  showTestCustomReportQueryParamModal,
}) => {
  const reset = useCallback(() => {
    hideCustomReportModalForParam();
    formik.resetForm();
  }, [formik, hideCustomReportModalForParam]);


  const [isOpenForSubmit, setOpenForSubmit] = useState(false);

  const { verifyQuery, isQueryType, optionsQueryParams } = useVerifyQueryLogic({
    formik, verifyParamOptionsQuery, setOpenForSubmit,
  });

  const submitAction = useCallback(() => {
    if (isQueryType && optionsQueryParams.length) {
      showTestCustomReportQueryParamModal();
      setOpenForSubmit(true);
      return;
    }
    if (isQueryType && !optionsQueryParams.length) {
      verifyQuery(null, { isOpenForSubmit: true });
      setOpenForSubmit(true);
      return;
    }
    formik.handleSubmit();
  }, [formik, verifyQuery, optionsQueryParams, isQueryType, showTestCustomReportQueryParamModal]);

  const handleSubmitParams = useCallback((params, { isOpenForSubmit }) => {
    verifyQuery(params, { isOpenForSubmit });
  }, [verifyQuery]);

  return (
    <>
      <Modal
        className="edit-param-modal"
        title="Edit Param"
        closeAction={reset}
        submitDisabled={formik.errors.length}
        dismissText="Cancel"
        dismissAction={reset}
        submitText="Save"
        submitAction={submitAction}
        isVisible={isVisible}
        isSubmitting={isVerifyingParamToEditQuery}
      >
        <Form
          formik={formik}
          schema={schema}
          openForEdit
          formContext={{
            paramTypesOptions,
            reportParamToEditOptions,
          }}
        />
      </Modal>
      <TestCustomReportQueryParamModal
        isVisible={testCustomReportQueryParamModalData.show}
        isOpenForSubmit={isOpenForSubmit}
        params={optionsQueryParams.length ? optionsQueryParams : null}
        hideModal={hideTestCustomReportQueryParamModal}
        onSubmitParams={handleSubmitParams}
      />
    </>
  );
};

EditCustomReportQueryParamModal.propTypes = {
  formik: FormikPropTypes.isRequired,
  schema: PropTypes.arrayOf(PropTypes.shape({})),
  hideModal: PropTypes.func.isRequired,
  reportParamToEditOptions: OptionsPropType,
  isVerifyingParamToEditQuery: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  verifyParamOptionsQuery: PropTypes.func.isRequired,
  testCustomReportQueryParamModalData: PropTypes.func.isRequired,
  showTestCustomReportQueryParamModal: PropTypes.func.isRequired,
  hideTestCustomReportQueryParamModal: PropTypes.func.isRequired,
  hideCustomReportModalForParam: PropTypes.func.isRequired,
};

export default EditCustomReportQueryParamModal;
